import cognitoAuth from '@/plugins/cognito'

let analytics_api_endpoint = process.env.ANALYTICS_API_ENDPOINT;
export default class analyticsApi {

  call (path, body, cb) {
    cognitoAuth.getIdToken(function(err, jwttoken) {
      if (err) {
        return cb(err)
      }
      var variables = ''
      var url = analytics_api_endpoint + path
      fetch(url, {
        method: 'post',
        mode: 'cors',
        body: JSON.stringify(body),
        headers: {
          'Accept': 'application/json',
          'Authorization': jwttoken
        }
      }).then(data => {
        if (data.status === 200) {
          return     data.json()
        }
      }).then(response => {
        return     cb(null, response )
      }).catch(err => {
        return cb(err)
      })
    })
  }

  onChange () {}
}

analyticsApi.install = function (Vue, options) {
  Object.defineProperty(Vue.prototype, '$analyticsApi', {
    get () { return this.$root._analyticsApi }
  })


}



// WEBPACK FOOTER //
// ./src/plugins/analyticsApi/analyticsApi.js